export const seasonalityTypeIds = {
  Seasonal: -1,
  Monthly: -2
}